import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const M1_STATUSES = new Set(["not_contacted", "emailed", "called", "responded", "demo_requested"]);
const M2_STATUSES = new Set(["meeting_booked", "demo_completed", "quote_sent", "trialing", "converted"]);

// Which admin-managed list applies to a prospect's current pipeline stage.
export const subTypeFor = (status) =>
  M1_STATUSES.has(status) ? "prospect_sub_status_to_demo"
    : M2_STATUSES.has(status) ? "prospect_sub_status_to_client"
      : null;

let _cache = null;
let _inflight = null;

export async function loadSubStatuses(force = false) {
  if (_cache && !force) return _cache;
  if (_inflight && !force) return _inflight;
  _inflight = (async () => {
    const [demo, client] = await Promise.all([
      axios.get(`${API}/lookups/prospect_sub_status_to_demo`).then((r) => r.data.items || []).catch(() => []),
      axios.get(`${API}/lookups/prospect_sub_status_to_client`).then((r) => r.data.items || []).catch(() => []),
    ]);
    const map = {};
    [...demo, ...client].forEach((it) => { map[it.key] = it.label; });
    _cache = { prospect_sub_status_to_demo: demo, prospect_sub_status_to_client: client, map };
    _inflight = null;
    return _cache;
  })();
  return _inflight;
}

// Hook: returns { map, listFor(status) } once loaded (null until then).
export function useSubStatuses() {
  const [state, setState] = useState(_cache);
  useEffect(() => {
    let ok = true;
    loadSubStatuses().then((s) => { if (ok) setState(s); });
    return () => { ok = false; };
  }, []);
  const listFor = (status) => {
    const t = subTypeFor(status);
    return (state && t) ? (state[t] || []) : [];
  };
  return { data: state, map: state?.map || {}, listFor };
}
